import { ROUTE } from 'constants/route';

const FooterLinks = [
  {
    title: 'Company',
    items: [
      {
        text: 'About Us',
        href: '/about',
      },
      {
        text: 'Library',
        href: '/library',
      },
      {
        text: 'Platform',
        href: '/candidates',
      },
    ],
  },
  {
    title: 'Employer',
    items: [
      // {
      //   text: 'Post a Job',
      //   href: '/contact',
      // },
      // {
      //   text: 'Start a Project',
      //   href: '/contact',
      // },
      {
        text: 'Claim a Profile',
        href: '/contact',
      },
    ],
  },
  {
    title: 'Candidates',
    items: [
      {
        anonymousOnly: true,
        text: 'Jobs',
        href: '/signup',
      },
      // {
      //   anonymousOnly: true,
      //   text: 'Projects',
      //   href: '/signup',
      // },
      {
        anonymousOnly: true,
        text: 'Sign Up',
        href: '/signup',
      },
      {
        candidateOnly: true,
        text: 'Jobs',
        to: ROUTE.JOBS,
      },
      // {
      //   candidateOnly: true,
      //   text: 'Projects',
      //   to: ROUTE.PROJECTS,
      // },
      {
        candidateOnly: true,
        text: 'Upgrade',
        to: ROUTE.CANDIDATE_UPGRADE_PREMIUM,
      },
    ],
  },
];

export default FooterLinks;
